/* eslint-disable */
import { ExternalLink } from "lucide-react";
import { formatCompactNumber, formatPercent } from "../pages/discordApi";
import { computePopoverPos } from "./discordBubbleUtils";

/** Hover card shared by the Market Mind and Tier Map bubble views. */
export default function DiscordBubbleTooltip({ datum, x, y, r, width, height }) {
  const pos = computePopoverPos({ x, y, r, containerWidth: width, containerHeight: height });
  const art = datum.splash_url || datum.banner_url || datum.icon_url;

  return (
    <div className="discord-market-pop" style={{ left: pos.left, top: pos.top, width: pos.width }}>
      {art && <img className="discord-market-pop-art" src={art} alt="" />}
      <div className="discord-market-pop-body">
        <div className="discord-market-pop-title">
          {datum.icon_url && (
            <img className="discord-market-pop-icon" src={datum.icon_url} alt="" />
          )}
          <strong title={datum.name}>{datum.name}</strong>
        </div>

        {(datum.verified || datum.partnered) && (
          <div className="discord-market-pop-badges">
            {datum.verified && <span>Verified</span>}
            {datum.partnered && <span>Partnered</span>}
          </div>
        )}

        <div className="discord-market-pop-stats">
          <span>
            <b>{formatCompactNumber(datum.members) ?? "—"}</b>Members
          </span>
          <span>
            <b>{formatCompactNumber(datum.online) ?? "—"}</b>Online
          </span>
          <span>
            <b>{formatPercent(datum.online_pct) ?? "—"}</b>Active
          </span>
          <span>
            <b>{formatCompactNumber(datum.boosts) ?? "—"}</b>Boosts
          </span>
        </div>

        {datum.games?.length > 0 && (
          <div className="discord-market-pop-games">
            {datum.games.slice(0, 3).map((g) => (
              <span key={g}>{g}</span>
            ))}
          </div>
        )}

        {datum.discord_url && (
          <a
            className="discord-market-pop-link"
            href={datum.discord_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ExternalLink size={12} /> Open in Discord
          </a>
        )}
      </div>
    </div>
  );
}
